<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';
  .alert{
    // width: 100vw;
    position: fixed;
    bottom: 0;
    padding: 20px;
    margin: space('narrow');
    border-style: solid;
    border-width: 1px;
    z-index: z-index(alert);
    &--succes{
      color: #3c763d;
      color: #3c763d;
      background-color: #dff0d8;
      border-color: #d6e9c6;
    }
    &--warning{
      color: #3c763d;
      background-color: color('warning');
      border-color: #d6e9c6;
    }
    &-enter-active {
      transition: all 0.25s ease-out;
    }
    &-leave-active {
      transition: all 0.5s ease-in-out;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(100%);
    }
  };
</style>
<template>
  <transition name="alert">
    <div class="alert alert--succes" v-show=isOpen>
      <button class="close" data-dismiss="alert" aria-label="close" title="close">×</button>
      <strong>Success!</strong> {{message}}
    </div>
  </transition>
</template>
<script>
import EventBus from '@/events/event-bus';

export default{
  data() {
    return {
      isOpen: false,
      message: '',
      timer: ''
    };
  },
  created() {
    EventBus.$on('showAlert', (message) => {
      this.showAllert(message);
    });
  },
  methods: {
    showAllert(message) {
      if (this.isOpen) clearTimeout(this.timer);
      this.message = message;
      this.isOpen = true;
      this.timer = setTimeout(this.hideAllert, 2000);
    },
    hideAllert() {
      this.isOpen = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/alerts.vue